import AxiosInstance from "../../helpers/axiosInstance"
import { store } from "../store"
//lang.file_path
export const getLanguagesFiles = async () => {
    await AxiosInstance.get(`${process.env.REACT_APP_BASE_URL}/api/v1/languages/get_translation_files`).then(function (response) {
        store.dispatch({ type: "storeTrans", payload: response.data })
        return (response.data)
    })
}